import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetFileList = async function(params) {
    try {
        const { parameters, locationPublicId } = params
        const queryUrl = '?' + qs.stringify(parameters)
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${locationPublicId}/download-area${queryUrl}`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}
export const DeleteFile = async function(file) {
    try {
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/download-area`,
            data: file,
        })
    } catch (e) {
        console.error(e)
    }
}
export const DeleteFolder = async function(folder) {
    try {
        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/download-area/folder`,
            data: folder,
        })
    } catch (e) {
        console.error(e)
    }
}

export const CreateItem = async function(item) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/download-area`,
            data: item,
            config: { headers: { 'Content-Type': 'multipart/form-data' } },
        })
    } catch (e) {
        console.error(e)
    }
}

export const EditFile = async function(file) {
    try {
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/download-area`,
            data: file,
            config: { headers: { 'Content-Type': 'multipart/form-data' } },
        })
    } catch (e) {
        console.error(e)
    }
}

export const RegiterDownload = async function(file) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/file-download/${file}`,
            data: file,
            config: { headers: { 'Content-Type': 'multipart/form-data' } },
        })
    } catch (e) {
        console.error(e)
    }
}
